import React from 'react';

const TriangleDown = ({ className }) => (
  <svg className={className} version="1.1" viewBox="130 288 10 5" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <polygon fill="#7E7E7E" fillRule="evenodd" points="135.166667 288 139.333333 293 131 293" stroke="none" transform="translate(135.166667, 290.500000) rotate(180.000000) translate(-135.166667, -290.500000) "></polygon>
  </svg>
);

export default TriangleDown;
